import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

function FiscalEmissionDeckInner({ lang, setLang }) {

  const { translations } = useTranslation();
  const t = translations && translations.ui ? translations.ui : { pageTitle: "The Full-Stack Fiscal Emission Platform | Hub", backToHub: "Back to Hub", iframeTitle: "The Full-Stack Fiscal Emission Platform" };

  // Update document title for this specific deck
  useEffect(() => {
    document.title = t.pageTitle;
    return () => {
      document.title = "Presentation Hub"; // Reset on unmount
    };
  }, []);

  return (
    <div className="relative w-full h-screen overflow-hidden bg-[#1d1f27]">
      {/* Back to Hub Overlay Button */}
      <Link 
        to="/" 
        className="absolute top-6 left-6 z-[9999] glass lift rounded-full px-4 py-2 flex items-center gap-2 text-white/80 hover:text-white border border-white/10 no-underline transition-all"
        style={{ background: 'rgba(20,20,20,0.5)', backdropFilter: 'blur(10px)' }}
      >
        <ChevronLeft className="w-4 h-4" />
        
        <span className="text-sm font-medium">{t.backToHub}</span>
      </Link>
      
      {/* Language Toggle */}
      <div className="absolute top-6 right-6 z-[9999]">
        <LanguageToggle lang={lang} setLang={setLang} />
      </div>


      {/* Embedded Live Presentation with Masking */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <iframe
          src="https://gamma.app/embed/foehrhja9jecyv1"
          className="w-full absolute top-0 left-0 border-none"
          style={{ height: 'calc(100% + 60px)' }} // Pushes the bottom watermark out of the viewport
          title={t.iframeTitle}
          allowFullScreen
        />
      </div>
    </div>
  );
}


import { TranslationProvider, useTranslation } from '../../shared/contexts/TranslationContext';
import { LanguageToggle } from '../../shared/components/LanguageToggle';

export function FiscalEmissionDeck() {
  const [lang, setLang] = React.useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("fiscal_emission_lang");
      if (stored === "pt" || stored === "en" || stored === "es") return stored;
      const nav = (navigator.language || "en").toLowerCase();
      if (nav.startsWith("es")) return "es";
      return nav.startsWith("pt") ? "pt" : "en";
    }
    return "en";
  });

  React.useEffect(() => {
    localStorage.setItem("fiscal_emission_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  return (
    <TranslationProvider deck="fiscal-emission" lang={lang}>
      <FiscalEmissionDeckInner lang={lang} setLang={setLang} />
    </TranslationProvider>
  );
}
